import { useRequiredParams } from '@pba/react-router';
import { OrganizationLayout, OrganizationsCommunities } from 'features/organizations';
import { useGetPathToEntityDetail } from '../../hooks';

const PageOrganizationsCommunities = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <OrganizationLayout organizationId={organizationId}>
      {(organization) => (
        <OrganizationsCommunities
          getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })}
          organization={organization}
        />
      )}
    </OrganizationLayout>
  );
};

export default PageOrganizationsCommunities;
